import React, { useState } from "react";
import { Snackbar } from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";
import ConfirmDeleteDialog from "../../../common/ConfirmDeleteDialog";

const Delete = ({ open, onClose, course, onRecordDeleted }) => {
  const { deleteData } = useFirestore("TpCourseShell");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      if (!course || !course.id) {
        throw new Error("Course ID is missing, cannot delete.");
      }
      await deleteData(course.id);
      setLoading(false);
      setSnackbarOpen(true);
      if (onRecordDeleted) {
        onRecordDeleted();
      }
      onClose();
    } catch (error) {
      console.error("Error deleting record:", error);
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <ConfirmDeleteDialog
        open={open}
        onClose={onClose}
        onConfirm={handleDelete}
        deleting={loading}
        title="Delete Record"
        message={
          course
            ? `Are you sure you want to delete this course shell record? Shell Name: ${
                course.shell_name || "N/A"
              }. This action cannot be undone.`
            : "Are you sure you want to delete this course shell record? This action cannot be undone."
        }
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Record has been deleted"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundColor: "red",
            color: "white",
          },
        }}
      />
    </>
  );
};

export default Delete;
